import { IUpdateControleUseCase } from "../../../presentation/useCases/update/update_controle_use_case";
import { IUpdateEntradaPUseCase } from "../../../presentation/useCases/update/update_entrada_produtos_use_case";
import { IUpdateSaidaPUseCase } from "../../../presentation/useCases/update/update_saida_produtos_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class UpdateControleUseCase implements IUpdateControleUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async updateControle(IdControleEstoque: number, IdCentroCusto?: number | null, Descricao?: string | null): Promise<void> {
    
    await this.repository.updateControle(IdControleEstoque, IdCentroCusto, Descricao
    );
  }
}
